<template>
    <svg height="96" viewBox="0 0 96 96" width="96" xmlns="http://www.w3.org/2000/svg">
        <!-- @vue-ignore -->
        <g fill="none" fill-rule="evenodd" stroke="currentColor" stroke-width="2">
            <circle cx="48" cy="48" r="39" />
            <path d="m24 48h48" />
        </g>
    </svg>
</template>
